import moment from "moment"
import { useEffect, useState } from "react"

export const Clock = () => {
  const [current, setCurrent] = useState<number>(moment.now())
  useEffect(() => {
    setInterval(() => {
      setCurrent(moment.now())
    }, 1000)
  }, [])
  const timezone = localStorage.getItem("timezone") || "+0000"
  return (
    <div className="flex justify-center mb-[16px]">
      <span className="text-[14px] leading-18 text-white font-medium">
        {moment(current).utcOffset(timezone).format("HH:mm:ss")}
      </span>
    </div>
  )
}
